import styled from 'styled-components';

import { Colour, MinBreakpointV2, Shadow } from '@xemplo/style-constants';

export const PromptDialogBase = styled.dialog`
  //reset default dialog styles
  border: none;
  padding: 0;

  //Dawn-UI specific dialog styles
  border-radius: 8px;
  max-width: calc(100% - 16px);
  ${Shadow.Medium3}
  &::backdrop {
    background-color: ${Colour.Gray[900]};
    opacity: 0.6;
  }
  &.system-prompt {
    &::backdrop {
      background-color: ${Colour.Light[100]};
    }
  }
`;

//Base Prompt Layout
export const PromptContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  border-radius: 8px;
  background: ${Colour.Light[100]};
  width: 100%;
  max-width: 400px;
  &.extended {
    @media ${MinBreakpointV2.medium} {
      max-width: 656px;
    }
  }
  &.system-prompt {
    background: ${Colour.Gray[800]};
    color: ${Colour.Light[100]};
  }
`;
